import api from '@/utils/api';

/**
 * 通用接口
 */

/**
 * 文件上传
 * @param {FormData} formData - 包含文件的 FormData
 * @returns {Promise}
 */
export function uploadFile(formData) {
  return api.post('/common/upload', formData);
}

